import styled from '@emotion/styled';
import { ClassAttributes, createElement } from 'react';
import { FormattedMessage } from 'react-intl';

interface Props {
  placement: {
    key: string;
    name: string;
  };
  className?: string;
}

const CreativeFormatPlacementLabel = ({ placement, className }: ClassAttributes<HTMLElement> & Props) => (
  <PlacementLabel className={className}>
    {placement.key !== 'any_network_any_placement' ? (
      placement.name
    ) : (
      <FormattedMessage id="creative_format.any_network_any_placement" />
    )}
  </PlacementLabel>
);

const PlacementLabel = styled('span')({
  lineBreak: 'anywhere',
});

export default CreativeFormatPlacementLabel;
